import {
  useGetPackageDetailsQuery,
  useGetPackageNotificationsQuery,
  useGetProjectDetailsQuery,
  useGetProjectsQuery,
} from "../../state-management/hooks";

export const isNullOrUndefined = <T>(
  obj: T | null | undefined
): obj is null | undefined => {
  return typeof obj === "undefined" || obj === null;
};

export const toCSSODateString = (
  input: Date | string | null | undefined
): string | null => {
  if (!input) {
    return null;
  }
  const date = new Date(input);
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  return `${month}/${day}/${year}`;
};

const projectData = useGetProjectDetailsQuery;
const packageDetails = useGetPackageDetailsQuery;
const packageNotifications = useGetPackageNotificationsQuery;
const projectDetails = useGetProjectDetailsQuery;
const projectsCollection = useGetProjectsQuery;

export default {
  projectData,
  packageDetails,
  packageNotifications,
  projectDetails,
  projectsCollection,
};
